export default {
    // A
    addToFolders: 'Add to folders',
    addToFoldersText: 'Add media to folders to categorize and group your media. Use folder master cards to easily request edits for specific groups of media.',

    // G
    goToFolders: 'Go to folders',

    // N
    noItemsFound: 'viewing 0 videos',

    // R
    requestEditFromFolder: 'Request edit from folder',
    requestEditFromFolders: 'Request edit from folders',
}
